import Vue from 'vue'
import router from '../router'
import store from '@/store';
import config from "./WebIMConfig";
import websdk from "easemob-websdk";
import _ from 'lodash'
import {
GetLawyerInfo
} from "@/api";

import { Toast,Dialog } from 'vant';
import bus from '@/utils/bus';
// 初始化IM SDK
var WebIM = {};
WebIM = window.WebIM = websdk;
WebIM.config = config;
WebIM.conn = new WebIM.connection({
  appKey: WebIM.config.appkey,
  isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
  https: WebIM.config.https,
  isAutoLogin: true,
  heartBeatWait: 30000,
  autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
  autoReconnectInterval: WebIM.config.autoReconnectInterval,
  isStropheLog: WebIM.config.isStropheLog,
  delivery: WebIM.config.delivery,
  useOwnUploadFun: WebIM.config.useOwnUploadFun,
  //公有云 isHttpDNS 默认配置为true
  isHttpDNS: WebIM.config.isHttpDNS,

  // 私有云设置，详细文档：http://docs-im.easemob.com/im/web/other/privatedeploy
  // isHttpDNS: false,
  // url: 'https://im-api-v2.easecdn.com/ws', // 设置为私有云的websocket server url
  // apiUrl: 'https://a1.easecdn.com', // 设置为私有云的rest server url
});
//通话状态
// const CALLSTATUS = {
// 	idle: 0,
// 	inviting: 1,
// 	alerting: 2,
// 	confirmRing: 3, // caller
// 	receivedConfirmRing: 4, // callee
// 	answerCall: 5,
// 	receivedAnswerCall: 6,
// 	confirmCallee: 7
// }
//律师+用户
Vue.prototype.loginIM = () => {
  if(localStorage.getItem('user')){
    var user = JSON.parse(localStorage.getItem('user'));
    var options = {
      user: user.MemberThirdId,
      pwd: '000000',
      appKey: WebIM.config.appkey,
      apiUrl: 'https://a1.easecdn.com'
    };
    WebIM.conn.open(options);
  }
}
var errorNum = 0,
  that = this
document.addEventListener('visibilitychange', () => {
console.log(router.history.current.path)
  console.log(document.hidden)
  var thispage=router.history.current.path
  if(thispage !='/video'&&thispage !='/notarization'&&thispage !='/order'&&thispage !='/law'&&thispage !='/mediate'&&thispage !='/judicial'&&thispage !='/calculator'&&thispage !='/agency'&&thispage !='/chatroom'){
    location.reload()
  }
  if (document.hidden) {
    // WebIM.conn.close()
  } else {
    // if (router.history.current.path != '/login') {
    //   setTimeout(() => {
    //     Vue.prototype.loginIM()
    //     errorNum = 0
    //   }, 1000)
    // }
  }
})
// 注册监听回调
WebIM.conn.listen({
  onOpened: function () { // 连接成功回调
    // 登录或注册成功后 跳转到好友页面
    console.log('连接成功')
    errorNum = 0
  },
  onClosed: function () {
    console.log('连接关闭')
    // router.push({name: 'Login'})
  }, // 连接关闭回调
  onTextMessage: function (message) {
    console.log('onTextMessage', message);
    saveMsg(message, 'text')
  }, // 收到文本消息
  onEmojiMessage: function (message) {
    console.log("onEmojiMessage", message);
    saveMsg(message, 'text')

  }, // 收到表情消息
  onPictureMessage: function (message) {
    console.log("onPictureMessage", message);
    saveMsg(message, 'picture')
  }, // 收到图片消息
  onCmdMessage: function (msg) {
    console.log('onCmdMessage', msg)

  },
  // 收到命令消息
  onAudioMessage: function (message) {
    console.log("onAudioMessage", message);
    saveMsg(message, 'audio')
  }, // 收到音频消息
  onLocationMessage: function (message) {
    console.log("onLocationMessage", message);
  }, // 收到位置消息
  onFileMessage: function (message) {
    console.log("onFileMessage", message);
    saveMsg(message, 'file')
  }, // 收到文件消息
  onVideoMessage: function (message) {
    console.log("onVideoMessage", message);

  }, // 收到视频消息
  onPresence: function (message) {
    console.log("onPresence", message);

	}, // 处理“广播”或“发布-订阅”消息，如联系人订阅请求、处理群组、聊天室被踢解散等消息
	onRoster: function (message) {
		console.log("onRoster", message);
	}, // 处理好友申请
	onInviteMessage: function (message) {
		console.log("onInviteMessage", message);
	}, // 处理群组邀请
	onOnline: function () {
		console.log("onOnline 网络已连接");
	}, // 本机网络连接成功
	onOffline: function () {
		console.log("onOffline 网络已断开");
		Toast({
			message: '网络已断开',
			duration: 1000,
		});
	}, // 本机网络掉线
	onError: function (message) {
		console.log('onError', message)
		var word = ''
		if (message.type == '206') {
			errorNum = 0
      location.reload()
			// Toast({
			// 	message: '账号已在其他设备登录',
			// 	duration: 1000,
			// });
      // console.log('账号已在其他设备登录')
			// router.push('/login?to=index')
      // localStorage.removeItem('user')
		} else {
			if (errorNum < 30) {
				errorNum++
				setTimeout(function () {
					Vue.prototype.loginIM()
				}, 1000)
			} else {
				Dialog.confirm({
					title:'提示',
					message:'连接已断开，请重连',
					confirmButtonText: '确定',
					showCancelButton: false,
				}).then(() => {
					setTimeout(function () {
						Vue.prototype.loginIM()
						errorNum = 0
					}, 1000)
				}).catch(() => {});
			}

      }
    }, // 失败回调
  onRecallMessage: message => {
    console.log("撤回消息", message);
    var msg = localStorage.getItem(message.from + message.to) ? JSON.parse(localStorage.getItem(message.from + message.to)) : [];
    // var chatList = localStorage.getItem(message.to + 'chatList') ? JSON.parse(localStorage.getItem(message.to + 'chatList')) : []
    var withTime = '';
    for (let i = 0; i < msg.length; i++) {
      if (msg[i].id === message.mid) {
        msg[i].type = "recall"
        withTime = getYMDHMS(parseInt(msg[i].time))
      }
    }
    localStorage.setItem(message.from + message.to, JSON.stringify(msg))
    store.dispatch('onNewMsg', msg)
    // store.dispatch("onUpdateMessageStatus", message);
  },
  onBlacklistUpdate: function (list) { // 黑名单变动
    // 查询黑名单，将好友拉黑，将好友从黑名单移除都会回调这个函数，list则是黑名单现有的所有好友信息
    // 更新好友黑名单
    console.log("黑名单变动", list);
    // let blackList = list;
    // Vue.$store.commit("updateBlackList", blackList);
  },
  onReceivedMessage: function (message) {
    // console.log("onReceivedMessage", message);
    // Vue.$store.commit("updateMessageMid", message);
    // message.status = "sent";
    // Vue.$store.commit("updateMessageStatus", message);
  }, // 收到消息送达服务器回执

  onDeliveredMessage: function (message) {
    // console.log("onDeliveredMessage", message);
    // Vue.$store.commit('updateMessageStatus', message)
  }, // 收到消息送达客户端回执

  onReadMessage: function (message) {
    console.log("onReadMessage", message);
    // message.status = "read";
    // Vue.$store.commit("updateMessageStatus", message);
  }, // 收到消息已读回执

  onCreateGroup: function (message) {
    console.log("onCreateGroup", message);
    // Vue.$store.dispatch("onGetGroupUserList");
  }, // 创建群组成功回执（需调用createGroupNew）
  onMutedMessage: function (message) {
    console.log("onMutedMessage", message);
  } // 如果用户在A群组被禁言，在A群发消息会走这个回调并且消息不会传递给群其它成员
});
function saveMsg(message, type) {
  var user = JSON.parse(localStorage.getItem('user'));
  var userThirdId, chatMsg, chatList, lawyerThirdId
  message.msgType = type
  console.log('saveMsg-------'+message.ext.ShowType)
  console.log(user)
  var thisPage=router.history.current.path
  if (message.ext.ShowType == "AIAnswer"|| message.ext.ShowType == "AIReasoningAnswer" || message.ext.ShowType == "ErrorCode"  || message.ext.Start == 'Start' || message.ext.End == 'End') {
            if (thisPage == '/robot') {
              if (message.ext.ShowType == "ErrorCode") {
                store.dispatch('onAIMsg', message.data)
              }else if (message.ext.Start == 'Start') {
                store.dispatch('onAIMsg', '')
                store.dispatch('onThinking', '')
              }else if (message.ext.End != 'End'){
                message.data = message.data.replace(/\n/g, '<br>')
                message.data = message.data.replace(/[**]|[###]/g, '')
                if (message.ext.ShowType == "AIReasoningAnswer") {
                  var thinking=store.state.Chat.thinking+message.data
                  store.dispatch('onThinking', thinking)
                } else {
                  var chatAIMsg=store.state.Chat.chatAIMsg+message.data
                  store.dispatch('onAIMsg', chatAIMsg)
                }
              }
              console.log('Vue.prototype.$thinking===',store.state.Chat.thinking)
                console.log('Vue.prototype.$chatAIMsg===',store.state.Chat.chatAIMsg)
              setTimeout(()=>{
                if(thisPage == '/robot'){
                store.dispatch('onNewMsg', message)
                }
              },500)
              
            } else {
              store.dispatch('onchatAILink',true)
              if (message.ext.Start == 'Start') {
                store.dispatch('onAIMsg', '')
                store.dispatch('onThinking', '')
              }else if (message.ext.End == 'End') {
                store.dispatch('onchatAILink',false)
                var last = JSON.parse(localStorage.getItem('chatAI_' + user.MemberThirdId))
                if (last[last.length - 1].count == 4) {
                  last[last.length - 1].show_count = true
                } else {
                  last[last.length - 1].show_count = false
                }
                last[last.length - 1].thinking = store.state.Chat.thinking
                last[last.length - 1].data = store.state.Chat.chatAIMsg
                localStorage.setItem('chatAI_' + user.MemberThirdId, JSON.stringify(last))
              } else {
                message.data = message.data.replace(/\n/g, '<br>')
                message.data = message.data.replace(/[**]|[###]/g, '')
                 if (message.ext.ShowType == "AIReasoningAnswer") {
                  var thinking=store.state.Chat.thinking+message.data
                  store.dispatch('onThinking', thinking)
                } else {
                  var chatAIMsg=store.state.Chat.chatAIMsg+message.data
                  store.dispatch('onAIMsg', chatAIMsg)
                }
                console.log('Vue.prototype.$thinking===',store.state.Chat.thinking)
                console.log('Vue.prototype.$chatAIMsg===',store.state.Chat.chatAIMsg)
              }
            }


          } else{
  if (message.to == user.MemberThirdId || message.from == user.MemberThirdId) {
    console.log(message.to)
    if (message.to == user.MemberThirdId) {
      lawyerThirdId = message.from;
      userThirdId = message.to
    } else {
      lawyerThirdId = message.to;
      userThirdId = message.from
    }
    chatMsg = localStorage.getItem(lawyerThirdId + userThirdId) ? JSON.parse(localStorage.getItem(lawyerThirdId + userThirdId)) : []
    console.log(chatMsg)
    
   
    if (message.ext.ShowType == 'GetOrder') {
      console.log('QiangDan-------'+message.from)
      // store.dispatch('onLawyerThirdId', message.from)
      // localStorage.setItem('chatroomLawyer', message.from)
      chatMsg.push(message)
      localStorage.setItem(lawyerThirdId + userThirdId, JSON.stringify(chatMsg))
      var orderInfo=JSON.parse(localStorage.getItem('orderInfo'))?JSON.parse(localStorage.getItem('orderInfo')):[]
      var OrderTitle = JSON.parse(localStorage.getItem('orderInfo')) ? JSON.parse(localStorage.getItem('orderInfo')).orderInfo.OrderTitle : ''
      localStorage.removeItem('orderInfo')
      var channel='zls'+new Date().getTime()
      if (OrderTitle == '视频咨询') {
        //跳视频
        router.replace('./video?lawyer='+message.from+ '&type=call&channel='+channel)
      } else if (OrderTitle == '服务咨询') {
        router.replace('./video?lawyer='+message.from+ '&type=call'+ '&orderguid=' + orderInfo.orderInfo.OrderGuid+'&channel='+channel)
      } else if (OrderTitle == '文书代写') {
      } else {
        if (thisPage == '/chatroom') {
          // window.serviceInfo()
        } else {
          GetLawyerInfo({
            "lawyerThird": lawyerThirdId
          }).then(res=>{
            if (res.state == 0) {
                var data = res.data
                if (thisPage == '/wait_directional') {
                  router.go(-1)
                } else {
                  setTimeout(()=>{
                    router.replace('./chatroom?lawyerGuid='+data.LawyerGuid)
                  },500)
                }
              } else {
                
              }
          })
          
        }
      }
      

    }else if(message.ext.AgoraCallType || message.ext.ShowType == "VideoOperation"){
       if (message.ext.AgoraCallType == 'VideoCall' && message.from != userThirdId) {
          chatMsg.push(message)
          if(thisPage != '/video'){
            localStorage.setItem(lawyerThirdId + userThirdId, JSON.stringify(chatMsg))
            router.push('./video?lawyer='+message.from+ '&type=ring&channel=' + message.ext.room)
          }else{
            var id = WebIM.conn.getUniqueId();
            var msg = new WebIM.message("txt", id);
            msg.set({
            msg: '对方忙线中', // 消息内容
            to: message.from, // 接收消息对象p17062609444088 p17090613481717
            chatType: 'singleChat',
            ext: {
                AgoraCallType: 'VideoBusy',
                room: message.ext.room
            },
            success() {
                var text = '忙线未接听'
                var data = {
                from: userThirdId,
                to: message.from,
                contentsType: 'TEXT',
                data: text,
                ext: {},
                time: Date.now(),
                type: 'chat'
                }
                chatMsg.push(data)
                localStorage.setItem(lawyerThirdId + userThirdId, JSON.stringify(chatMsg))
            },
            fail() {

            }
            })
            WebIM.conn.send(msg.body);
          }
          return;
       }
       
       if (message.ext.ShowType == "VideoOperation" ) {
        
        }
        if (message.ext.business_order) {
          //  chatMsg.push(message)
          //  localStorage.setItem(lawyerThirdId + userThirdId, JSON.stringify(chatMsg))
          // store.dispatch('onNewMsg', message)
          // return;
        }
        chatMsg.push(message)
        localStorage.setItem(lawyerThirdId + userThirdId, JSON.stringify(chatMsg))
        store.dispatch('onNewMsg', message)
        return
    }else if (message.ext.ShowType && (message.ext.ShowType == 'InviteComment' || message.ext.ShowType == 'Comment')) {
        chatMsg.push(message)
      } else if (message.ext.ShowType && message.ext.ShowType == 'TaskFinish') {
        if (thisPage == '/lawful') {
          // thisPage.setData({
          //   showCelebrate: true,
          //   point: message.ext.points,
          //   name: message.ext.taskName,
          // })
        } else {
          localStorage.setItem('TaskFinish', JSON.stringify(message.ext))
        }
      } else if (!message.ext.ShowType) {
        chatMsg.push(message)
        if (thisPage == '/chatroom') {
          // thisPage.dealLZ(message)
        }

      }
    localStorage.setItem(lawyerThirdId + userThirdId, JSON.stringify(chatMsg))
    store.dispatch('onNewMsg', message)
    if (message.to == user.MemberThirdId) {
      var noreadnum = localStorage.getItem(lawyerThirdId + userThirdId + '_noread') ? localStorage.getItem(lawyerThirdId + userThirdId + '_noread') : 0
      var noreadtotal=localStorage.getItem(user.MemberThirdId+'_noread') ? localStorage.getItem(user.MemberThirdId+'_noread'): 0;
      if(message.ext.ShowType && (message.ext.ShowType == 'InviteComment' || message.ext.ShowType == 'Comment' )){
        noreadtotal++
        localStorage.setItem(lawyerThirdId + userThirdId + '_noread', parseInt(noreadnum) + 1)
        localStorage.setItem(user.MemberThirdId+'_noread',noreadtotal)
        // store.dispatch('onnoreadtotal', parseInt(noreadtotal) + 1)
      }else if(!message.ext.ShowType){
        noreadtotal++
        localStorage.setItem(lawyerThirdId + userThirdId + '_noread', parseInt(noreadnum) + 1)
        localStorage.setItem(user.MemberThirdId+'_noread',noreadtotal)
        // store.dispatch('onnoreadtotal', parseInt(noreadtotal) + 1)
      }
      if (thisPage == '/index' || thisPage == '/chat' || thisPage == '/my') {
        if (noreadtotal > 0) {
          bus.$emit('addred', {
              state: 1
          })
        } else {
          bus.$emit('addred', {
              state: 0
          })
        }
      }
    }
  }
  }
}

function getYMDHMS(timestamp) {
  let time = new Date(timestamp)
  // let year = time.getFullYear()
  let month = time.getMonth() + 1
  let date = time.getDate()
  let hours = time.getHours()
  let minute = time.getMinutes()
  // let second = time.getSeconds()

  if (month < 10) {
    month = '0' + month
  }
  if (date < 10) {
    date = '0' + date
  }
  if (hours < 10) {
    hours = '0' + hours
  }
  if (minute < 10) {
    minute = '0' + minute
  }
  // if (second < 10) { second = '0' + second }
  // return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
  return month + '月' + date + '日 ' + hours + ':' + minute
}

export default WebIM;
